import { type SxProps } from '@mui/system'
import React, { type ReactElement, type ReactNode } from 'react'
import { Button } from '@mui/material'

import { BUTTON_SIZE, BUTTON_VARIANTS, type ThemeButtonProps } from '../theme-button/ThemeButton'

import type Theme from 'common/utils/theme'

interface IconButtonProps extends ThemeButtonProps {
  variant?: BUTTON_VARIANTS | undefined
  border?: string
  icon: ReactNode
  sx?: SxProps<typeof Theme>
}

const IconButton: React.FC<IconButtonProps> = ({
  variant = BUTTON_VARIANTS.primary,
  size = BUTTON_SIZE.large,
  icon,
  sx,
  ...rest
}): ReactElement => {
  return (
    <Button
      sx={{
        width: size === BUTTON_SIZE.large ? '32px' : '20px',
        minWidth: size === BUTTON_SIZE.large ? '32px' : '20px',
        height: size === BUTTON_SIZE.large ? '32px' : '20px',
        padding: 0,
        ...(sx ?? {}),
      }}
      variant={variant}
      {...rest}
    >
      {icon}
    </Button>
  )
}

export default IconButton
